// Mirrored bridge of server canonical persisted/domain league-level error codes.
// Keep import path stable for existing web usage; parity is enforced by scripts/check-constant-parity.js.
export const LEAGUE_LEVEL_ERROR_CODES = Object.freeze({
  CROSS_LEVEL_PLACEMENT_NOT_ALLOWED: 'cross_level_placement_not_allowed',
  PLACEMENT_LEVEL_INACTIVE: 'placement_level_inactive',
  REVERT_BLOCKED_AFTER_SCHEDULING: 'revert_blocked_after_scheduling',
  REVERT_STALE: 'revert_stale',
  DIVISION_MISSING_LEVEL: 'division_missing_level',
  OVERRIDE_REASON_REQUIRED: 'OVERRIDE_REASON_REQUIRED',
})

export const CROSS_LEVEL_PLACEMENT_NOT_ALLOWED =
  LEAGUE_LEVEL_ERROR_CODES.CROSS_LEVEL_PLACEMENT_NOT_ALLOWED
export const PLACEMENT_LEVEL_INACTIVE =
  LEAGUE_LEVEL_ERROR_CODES.PLACEMENT_LEVEL_INACTIVE
export const REVERT_BLOCKED_AFTER_SCHEDULING =
  LEAGUE_LEVEL_ERROR_CODES.REVERT_BLOCKED_AFTER_SCHEDULING
export const REVERT_STALE = LEAGUE_LEVEL_ERROR_CODES.REVERT_STALE
export const DIVISION_MISSING_LEVEL =
  LEAGUE_LEVEL_ERROR_CODES.DIVISION_MISSING_LEVEL
export const OVERRIDE_REASON_REQUIRED =
  LEAGUE_LEVEL_ERROR_CODES.OVERRIDE_REASON_REQUIRED
